import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { User } from "../types";

interface UserState {
  users: User[];
  loading: boolean;
  error: string | null;
  selectedUser: User | null;
}

const initialState: UserState = {
  users: [],
  loading: false,
  error: null,
  selectedUser: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    fetchUsersStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchUsersSuccess: (state, action: PayloadAction<User[]>) => {
      state.loading = false;
      state.users = action.payload;
    },
    fetchUsersFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    addUserRequest: (state, action: PayloadAction<FormData>) => {},
    addUserSuccess: (state, action: PayloadAction<User>) => {
      state.users.push(action.payload);
    },
    addUserFailure: (state, action: PayloadAction<string>) => {
      console.error(action.payload);
    },
    fetchUserByIdRequest: (state, action: PayloadAction<number>) => {
      state.loading = true;
      state.error = null;
    },
    fetchUserByIdSuccess: (state, action: PayloadAction<User>) => {
      state.selectedUser = action.payload;
      state.loading = false;
    },
    fetchUserByIdFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    updateUserRequest: (state, action: PayloadAction<{ id: number; data: Partial<FormData> }>) => {
      state.loading = true;
    },
    updateUserSuccess: (state, action: PayloadAction<User>) => {
      state.loading = false;
      state.users = state.users.map((user) =>
        user.id === action.payload.id ? action.payload : user
      );
    },
    updateUserFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { 
  fetchUsersStart, fetchUsersSuccess, fetchUsersFailure, 
  addUserRequest, addUserSuccess, addUserFailure,  
  fetchUserByIdRequest, fetchUserByIdSuccess, fetchUserByIdFailure,
  updateUserRequest, updateUserSuccess, updateUserFailure,
} = userSlice.actions;
export default userSlice.reducer;
